import Dossie from './Dossie/Dossie';
import Receipt from './Receipt/Receipt';
import { withRouter } from "react-router";
import Proposal from './Proposal/Proposal';
import ExportDRE from './Finance/ExportDRE';
import {PDFViewer} from '@react-pdf/renderer';
import React, {Component, Fragment } from 'react';
import ShippingLabel from './Shipping/ShippingLabel';
import PeopleMergeLog from './People/PeopleMergeLog';
import CartaCorrecao from './NotaFiscal/CartaCorrecao';
import OrderService from './OrderService/OrderService';
import FinanceMoviment from './Finance/FinanceMoviment';
import OrderProduction from './OrderProduction/OrderProduction';
import { displayCEP, onlyNumber, displayDate, formatMoney, b64_to_utf8, formatPhoneNumber, valueIsNull } from '@iso/lib/helpers/utility';

let invoiceData = {};

export default withRouter(class App extends Component {

    makeReport = async (props) => {
        this.reportType = props.match.params.type;
        
        if(props.match.params.type === 'dossie') {
            const itemProposta = JSON.parse(b64_to_utf8(sessionStorage.getItem('itemProposta')));

            this.reportItem = <Dossie data={itemProposta}/>
        }
        else if(props.match.params.type === 'ordem_servico') {
            const data = JSON.parse(b64_to_utf8(sessionStorage.getItem('itemProposta')));

            data.title = 'Ordem de serviço';
            data.type = 'Service';

            this.reportItem = <OrderService data={data}/>
        }
        else if(props.match.params.type === 'movimentacao_financeira') {
            
            const dataEmpresa = JSON.parse(b64_to_utf8(sessionStorage.getItem('employeData')));
            let data = JSON.parse(b64_to_utf8(sessionStorage.getItem('exportDataFinance')));

            data.empresa = dataEmpresa;
            data.title = 'Movimentação financeira';
            // data.moviment_dates = '12/10/2024 à 14/10/2025';

            this.reportItem = <FinanceMoviment data={data}/>
        }
        else if(props.match.params.type === 'ordem_producao') {
            let data = {};
            const orderProductionData = JSON.parse(b64_to_utf8(sessionStorage.getItem('orderProductionData')));
            // console.log(orderProductionData)

            data.title = `Ordem de produção`; // "${orderProductionData.product.name}"
            data.type = 'Production';
            data.orderProduction = orderProductionData;

            // console.log(data)
            this.reportItem = <OrderProduction sourceData={data}/>
        }
        else if(props.match.params.type === 'romaneio_producao') {
            const data = JSON.parse(b64_to_utf8(sessionStorage.getItem('itemProposta')));

            data.title = 'Romaneio de produção';
            data.type = 'Romaneio';

            // console.log(data)
            this.reportItem = <OrderService data={data}/>
        }
        else if(props.match.params.type === 'carta_correcao') {
            const aux = JSON.parse(b64_to_utf8(sessionStorage.getItem('CartaCorrecao')));

            // console.log(aux)

            let data = aux.carta.correcao;
            data.ambiente = (aux.carta.ambiente === 'P') ? 'Produção' : 'Homologação';
            data.cpf_cnpj = aux.account.cpf_cnpj;
            data.sefaz.chave = aux.carta.retorno_sefaz.chave;
            data.sefaz.mensagem = `Código ${data.sefaz.codigo}: ${data.sefaz.mensagem}, protocolo ${data.sefaz.protocolo}`;

            data.title = 'Carta de correção';

            this.reportItem = <CartaCorrecao data={data}/>
        }
        else if(props.match.params.type === 'etiqueta_envio') {

            const itemProposta = JSON.parse(b64_to_utf8(sessionStorage.getItem('itemProposta')));
            const dataEmpresa = JSON.parse(b64_to_utf8(sessionStorage.getItem('employeData')));
            // console.log(itemProposta);
            // console.log(dataEmpresa);

            invoiceData['empresa'] = dataEmpresa;
            invoiceData['client'] = itemProposta.client;

            this.reportItem = <ShippingLabel data={invoiceData}/>;
        }
        else if(props.match.params.type === 'dre') {
            const aux = JSON.parse(b64_to_utf8(sessionStorage.getItem('exportDataDre')));

            console.log(aux)
            
            this.reportItem = <ExportDRE data={aux}/>;
        }
        else if(props.match.params.type === 'recibo') {
            const aux = JSON.parse(b64_to_utf8(sessionStorage.getItem('Bill')));
            const dataEmpresa = JSON.parse(b64_to_utf8(sessionStorage.getItem('employeData')));
            const paymentForms = JSON.parse(b64_to_utf8(sessionStorage.getItem('PaymentForms')));

            // console.log(aux)
            // console.log(dataEmpresa)

            // clientName:  "Nova pessoa teste baiano"
            // dueDate:  "2024-06-19T03:00:00.000Z"
            // financySituation : "Paga"
            // history : "Parcela 1 de 4"
            // installment :  "b9e74bb1-eabd-4add-998a-454b5ef5cbc7"
            // key :  "1.ma9pxqo04a"
            // situation: "Ativo"
            // type : "Receber"
            // value:  0

            invoiceData['bill'] = aux;
            invoiceData['empresa'] = dataEmpresa;
            invoiceData['paymentForms'] = paymentForms;

            this.reportItem = <Receipt data={invoiceData}/>;
        }
        else if(props.match.params.type === 'merge_people_report') {

            let people = JSON.parse(b64_to_utf8( localStorage.getItem('people')))
            let users = JSON.parse(b64_to_utf8( sessionStorage.getItem('users')))
            let data = JSON.parse(b64_to_utf8( localStorage.getItem('people_merge')))
            let filter_data = JSON.parse(b64_to_utf8( sessionStorage.getItem('filter_data')))

            invoiceData['users'] = users;
            invoiceData['merges'] = data;
            invoiceData['people'] = people;
            invoiceData['filter_data'] = filter_data;
            invoiceData['title'] = 'Relatório de agrupamento de pessoas';

            this.reportItem = <PeopleMergeLog data={invoiceData}/>;
        }
        else if(props.match.params.type === 'proposta') {

            let products = JSON.parse(localStorage.getItem('prods_reds'));

            const itemProposta = JSON.parse(b64_to_utf8(sessionStorage.getItem('itemProposta')));
            const dataEmpresa = JSON.parse(b64_to_utf8(sessionStorage.getItem('employeData')));
            const currentBlocks = JSON.parse(b64_to_utf8(sessionStorage.getItem('cur__blocs')));

            var itens = [];
            if(typeof itemProposta.productsAndServices != 'undefined')
                itens = itens.concat(itemProposta.productsAndServices);

            // new RegExp
            // let testReplace = valueIsNull(itemProposta?.contractModel).replace('(?:font-family)[ ]*:[ ]*[^;]+;', "");
            // let testReplace = new RegExp('(?:font-family)[ ]*:[ ]*[^;]+;', "g");valueIsNull(itemProposta?.contractModel).replace('(?:font-family)[ ]*:[ ]*[^;]+;', "");
            // let testReplace = valueIsNull(itemProposta?.contractModel).replace(/(style="[^"]*)font-family:[^;]+;?([^"]*")/gi, '$1$2');
            // let testReplace = valueIsNull(itemProposta?.contractModel).replace(/font-family[^;]+;?/g, '');;

            /*
            let testReplace =  '';
            if( typeof itemProposta?.contractModel !== 'undefined' && itemProposta?.contractModel !== null && itemProposta?.contractModel !== '') {
                testReplace =  itemProposta?.contractModel.replace(/font-family[^;]?/g, '');
                testReplace = testReplace.replace(/Arial/g, '');
            }

            // console.log(testReplace);
            */
            let testReplace = valueIsNull(itemProposta?.contractModel).replace(/font-family[^;]?/g, '');
            testReplace = testReplace.replace(/Arial/g, '');
            // console.log(testReplace);

            invoiceData = {
                items: itens,
                id: "5df3180a09ea16dc4b95f910",
                invoice_no: String(onlyNumber(itemProposta._id)).slice(0, 8),
                company: itemProposta.client?.name,
                email: itemProposta.client?.email,
                attendant: valueIsNull(itemProposta?.attendant),
                condicaoComercial: itemProposta?.condicaoComercial,
                contractModel: testReplace,
                phone: formatPhoneNumber(itemProposta.client?.fone),
                products: products,
                trans_date: displayDate("2019-09-12"),
                due_date: "2019-10-12",
                empresa: dataEmpresa,
                currentBlocks: currentBlocks,
                balance: formatMoney((itemProposta?.budgetAmount) ? itemProposta?.budgetAmount : 0)
            }

            if(typeof itemProposta?.additionalInfo !== 'undefined')
                invoiceData['additionalInfo'] = itemProposta?.additionalInfo;

            if(itemProposta.client && itemProposta.client?.address) {
                var txt = itemProposta.client?.address?.address
                if(itemProposta.client?.address?.numberHouse)
                    txt = txt+', '+itemProposta.client?.address?.numberHouse

                if(itemProposta.client?.address?.neighborhood)
                    txt = txt+', '+itemProposta.client?.address?.neighborhood

                if(itemProposta.client?.address?.complement)
                    txt = txt+', '+itemProposta.client?.address?.complement

                if(itemProposta.client?.address?.city)
                    txt = txt+', '+itemProposta.client?.address?.city+'/'+itemProposta.client?.address?.state+'.'

                if(itemProposta.client?.address?.cep)
                    txt = txt+' CEP: '+displayCEP(itemProposta.client?.address?.cep)

                invoiceData.address = txt
            }

            if(itemProposta.client && itemProposta.client?.cpf_cnpj)
                invoiceData.cpf_cnpj = itemProposta.client?.cpf_cnpj

            if(itemProposta.client && itemProposta.client?.rg_ie)
                invoiceData.rg_ie = itemProposta.client?.rg_ie

            if(itemProposta.vehicle)
                invoiceData.vehicle = itemProposta.vehicle;

            if(itemProposta.address) {
                var txt = itemProposta.address?.address
                if(itemProposta.address?.numberHouse)
                    txt = txt+', '+itemProposta.address?.numberHouse

                if(itemProposta.address?.neighborhood)
                    txt = txt+', '+itemProposta.address?.neighborhood

                if(itemProposta.address?.complement)
                    txt = txt+', '+itemProposta.address?.complement

                if(itemProposta.address?.city)
                    txt = txt+', '+itemProposta.address?.city+'/'+itemProposta.address?.state+'.'

                if(itemProposta.address?.cep)
                    txt = txt+' CEP: '+displayCEP(itemProposta.address?.cep)

                invoiceData.secondAddress = txt
            }

            this.reportItem = <Proposal invoice={invoiceData}/>;
        }
    }

    constructor(props) {
        super(props);
        this.makeReport(props);
    }

    render() {
        return (
          <Fragment>
              <PDFViewer width="1000" height="600" className="app" >
                  { this.reportItem }
              </PDFViewer>
          </Fragment>
        );
    }
  }
)